module.exports = __webpack_public_path__ + "static/media/icon-3d-light.bbe5b96c.svg";